import axios_ from "../utils/axios";
import { translateContent } from "./translateFetch";
import { usePyRequest } from "@/api/usePyConfig";
export default {
  /**
   * 邮箱列表
   * @param {*} param
   * @returns
   */
  getBotEamilLists(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/serviceEmail/lists`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 邮箱 新增、编辑
   * @param {*} param
   * @returns
   */
  storeBotEamil(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/serviceEmail/${param.id ? "update" : "insert"}`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 邮箱详情
   * @param {*} param
   * @returns
   */
  getBotEamilDetail(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/serviceEmail/detail`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 邮箱删除
   * @param {*} param
   * @returns
   */
  delBotEamil(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/serviceEmail/del`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 修改管理员
   * @param {*} param
   * @returns
   */
  uptEmailAdmin(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/serviceEmail/upAdministrators`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 开启自动回复开关
   * @param {*} param
   * @returns
   */
  emailSwitchReply(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/serviceEmail/updateReply`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 邮箱 - 邮件列表
   * @param {*} param
   * @returns
   */
  botEmailList(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/serviceEmailDetail/lists`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 邮箱 - 邮件详情
   * @param {*} param
   * @returns
   */
  botEmailMessageDetail(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/serviceEmailDetail/detail`, param, false).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 邮箱 - 回复邮件
   * @param {*} param
   * @returns
   */
  botEmailInsertMessage(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/serviceEmailDetail/insert`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 邮箱 - 邮件刷新
   * @param {*} param
   * @returns
   */
  getEmailDetails(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/serviceEmail/getEmailDetails`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 邮箱 - 邮件翻译（已切换到统一接口，调用方需传文本内容）
   * @param {*} param
   * @returns {Promise<{code:number;msg:string;data:string}>}
   */
  translateEmail(param) {
    return translateContent("", param);
  },
  /**
   * 邮件机器人 场景设置 获取变量
   * @param {*} data
   * @returns
   */
  getTemplateVariables(data) {
    return axios_("GET", `api/pandagpt/v1/csScene/getTemplateVariables`, data);
  },
  /**
   * 邮件机器人 场景设置 初始化接口
   * @param {*} data
   * @returns
   */
  getReplyTemplate(data) {
    return axios_("GET", `api/pandagpt/v1/csScene/getReplyTemplate`, data);
  },
  /**
   * @typedef {Object} SetHeaderTailRequest
   * @property {string} id 邮箱机器人id
   * @property {string} header_file 头文件模板
   * @property {string} tail_file 头文件模板
   */
  /**
   * 修改邮件头尾文件
   * @param {SetHeaderTailRequest} param
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  setHeaderTail(param) {
    return axios_("POST", `api/pandagpt/v1/serviceEmail/setHeaderTail`, param);
  },
  /**
   * @typedef {Object} EmailListItem
   * @property {string} email_account_id
   * @property {string} email
   * @property {string} introduction
   * @property {string} team_user_id
   * @property {string} team_user_name
   * @property {string} created_at
   */
  /**
   * 获取邮件列表
   * @param {string} id 邮箱机器人id
   * @returns {Promise<{code:number;msg:string;data:EmailListItem[]}>}
   */
  getEmailList(id) {
    return axios_("GET", "api/pandagpt/v1/serviceEmail/getEmailList", {
      id
    });
  },
  /**
   * 删除已绑定邮箱
   * @param {string} email_account_id
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  delEmailAccount(email_account_id) {
    return axios_("POST", "api/pandagpt/v1/serviceEmail/delEmailAccount", {
      email_account_id
    });
  },
  /**
   * 绑定新邮箱
   * @param params
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  addEmail(params) {
    return axios_("POST", "api/pandagpt/v1/serviceEmail/addemail", params);
  },
  /**
   * 获取邮箱基础数据
   * @param params
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  getEmailConfig(params) {
    return axios_("GET", "api/pandagpt/v1/serviceEmail/getEmailConfig", params);
  },
  /**
   * 邮箱详情
   * @param {*} param
   * @returns
   */
  getEmailAccount(params) {
    return axios_("GET", "api/pandagpt/v1/serviceEmail/getEmailAccount", params);
  },
  /**
   * 验证邮件
   * @param {*} param
   * @returns
   */
  verifyEmail(params) {
    return axios_("POST", "api/pandagpt/v1/serviceEmail/verifyEmail", params);
  },
  /**
   * 机器人运营开关
   * @param {{cs_id:string;cs_type:string;operate_status:1|2}} params
   * @returns {Promise<{code:number;msg:string;data:any}>}
   */
  setOperationSwitch(params) {
    return axios_("POST", "api/pandagpt/v1/cs/setOperationSwitch", params);
  },
  /**
   * 邮件标为已读
   * @param ids
   * @returns {Promise<DefaultResponseType>}
   */
  emailsProcessing(ids) {
    return axios_("post", "api/pandagpt/v1/serviceEmailDetail/emailsProcessing", {
      ids
    });
  }
};

/**
 * 获取邮件快捷回复列表
 * @param {string} title
 * @return {Promise<DefaultResponseType>}
 */
export function email_quick_reply_list(title) {
  return usePyRequest("get", "api/pandagpt/v1/email_quick_reply/list", {
    title
  });
}

/**
 * 添加快捷回复
 * @param title
 * @param content
 * @returns {Promise<DefaultResponseType<Array<{content:string; created_at:string;id:number; is_del:number; team_id:string; title:string; update_at:string;}>>>}
 */
export function email_quick_reply_add(title, content) {
  return usePyRequest("POST", "api/pandagpt/v1/email_quick_reply/add", {
    title,
    content
  });
}

/**
 * 修改快捷回复
 * @param {{id:string; title:string; content:string}} query
 * @return {Promise<DefaultResponseType>}
 */
export function email_quick_reply_update(query) {
  return usePyRequest("POST", "api/pandagpt/v1/email_quick_reply/update", query);
}

/**
 * 删除邮件快捷回复
 * @param id
 * @return {Promise<DefaultResponseType>}
 */
export function email_quick_reply_delete(id) {
  return usePyRequest("POST", "api/pandagpt/v1/email_quick_reply/delete", {
    id
  });
}

/**
 * 邮箱机器人统计表-获取汇总数据
 * @returns {Promise<DefaultResponseType>}
 */
export function mail_statistics_summary(start_date, end_date) {
  return usePyRequest("GET", "api/pandagpt/v1/mail_statistics/summary", {
    start_date,
    end_date
  });
}

/**
 * 邮箱机器人统计表-邮件回复占比柱状图
 * @param start_date
 * @param end_date
 * @returns {Promise<DefaultResponseType>}
 */
export function mail_statistics_daily_chart(start_date, end_date) {
  return usePyRequest("GET", "api/pandagpt/v1/mail_statistics/daily_chart", {
    start_date,
    end_date
  });
}

/**
 * 邮箱机器人统计表-邮件处理趋势饼图
 * @param start_date
 * @param end_date
 * @returns {Promise<DefaultResponseType>}
 */
export function mail_statistics_reply_pie(start_date, end_date) {
  return usePyRequest("GET", "api/pandagpt/v1/mail_statistics/reply_pie", {
    start_date,
    end_date
  });
}

/**
 * 邮箱机器人统计表-邮件列表
 * @param query
 * @return {Promise<DefaultResponseType>}
 */
export function mail_statistics_email_detail(query) {
  return usePyRequest("GET", "api/pandagpt/v1/mail_statistics/email_detail", query);
}

/**
 * 邮箱机器人统计表-用户邮件分析(坐席明细)
 * @param query
 * @return {Promise<DefaultResponseType>}
 */
export function mail_statistics_user_summary(query) {
  return usePyRequest("GET", "api/pandagpt/v1/mail_statistics/user_summary", query);
}

/**
 * 已回复邮件翻译
 * api/pandagpt/v1/mail/email_detail
 */
export function mail_email_detail(id, target_lang) {
  return usePyRequest("get", "api/pandagpt/v1/mail/email_detail", {
    id,
    target_lang
  });
}